import React from 'react';
import ResultStatus from './ResultStatus';
import { TABResult } from '../types/ab';
import {  PromotedIcon } from 'assests/GmsIcons';

type Row = {
    result: TABResult[];
}

type ResultsListProps = {
    row: Row;
    rowIndex: number;
}

const ResultsList = ({ row, rowIndex }: ResultsListProps) => {

    if (!row?.result) {
        return null;
    }

    const sortedResults = [...row.result].sort((a: TABResult, b: TABResult) => {
        if (a.is_control && !b.is_control) return -1;
        if (!a.is_control && b.is_control) return 1;
        return 0;
    });

    return (
        <div className="flex flex-col gap-2">
            {sortedResults.map((result) => (
                <div className='tw-flex tw-items-center tw-gap-1.5' key={`result-${rowIndex}-${result.name}`}>
                    <ResultStatus
                        status={result.is_control ? undefined : result.result_status}
                        modelName={result.name}
                    />
                    {result?.is_promoted ? <PromotedIcon /> : null}
                </div>
            ))}
        </div>
    );
};

export default ResultsList;